// src/api/adminUsersApi.js
import { adminJson } from "./adminHttp";

export function listAdminUsers() {
  return adminJson("/admin/admin-users");
}

export function createAdminUser(payload) {
  return adminJson("/admin/admin-users", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateAdminStatus(id, status, reason) {
  return adminJson(`/admin/admin-users/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status, reason }),
  });
}
